"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatSelectionField = exports.OptionalTextField = exports.CategoryField = exports.EmotionField = exports.FeedbackField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_2 = require("@tiptap/react");
var RadioGroup = __importStar(require("@radix-ui/react-radio-group"));
// import {RadioGroup} from '@headlessui/react'
var formik_1 = require("formik");
var extension_typography_1 = __importDefault(require("@tiptap/extension-typography"));
var extension_highlight_1 = __importDefault(require("@tiptap/extension-highlight"));
var starter_kit_1 = __importDefault(require("@tiptap/starter-kit"));
var extension_link_1 = __importDefault(require("@tiptap/extension-link"));
var client_1 = require("@skillrecordings/skill-api/dist/client");
var FeedbackField = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Your feedback' : _b, errors = _a.errors, touched = _a.touched, isSubmitted = _a.isSubmitted, _c = _a.showMarkdown, showMarkdown = _c === void 0 ? true : _c;
    var field = (0, formik_1.useField)({ name: 'text' })[0];
    var editor = (0, react_2.useEditor)({
        // @ts-ignore
        extensions: [starter_kit_1.default, extension_highlight_1.default, extension_typography_1.default, extension_link_1.default],
        content: field.value,
        onUpdate: function (_a) {
            var editor = _a.editor;
            field.onChange({ target: { value: editor.getHTML(), name: 'text' } });
        },
        onBlur: function (_a) {
            var event = _a.event;
            field.onBlur(event);
        },
        editorProps: {
            attributes: {
                id: 'text',
                name: 'text',
            },
        },
    });
    var isEmpty = editor === null || editor === void 0 ? void 0 : editor.isEmpty;
    react_1.default.useEffect(function () {
        var _a;
        if (isEmpty) {
            field.onChange({ target: { value: '', name: 'text' } });
        }
        if (isSubmitted) {
            (_a = editor === null || editor === void 0 ? void 0 : editor.commands) === null || _a === void 0 ? void 0 : _a.clearContent();
        }
    }, [isEmpty, isSubmitted]);
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-feedback-field": "", children: [(0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-feedback-field-header": "", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "text", children: [label, " ", (0, jsx_runtime_1.jsx)("span", { children: "(required)" })] }), errors.text && touched.text ? ((0, jsx_runtime_1.jsx)("div", { "aria-live": "polite", children: errors.text })) : null] }), (0, jsx_runtime_1.jsx)("div", { "data-sr-feedback-widget-feedback-field": errors.text && touched.text ? 'error' : '', children: (0, jsx_runtime_1.jsx)(react_2.EditorContent, { editor: editor, name: "text", id: "text" }) }), showMarkdown && (0, jsx_runtime_1.jsx)("small", { children: "Styling with markdown is supported." })] }));
};
exports.FeedbackField = FeedbackField;
var EmotionField = function (props) {
    var field = (0, formik_1.useField)({ name: props.name })[0];
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-emotion-field": "", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "context.emotion", children: "Emotion" }), (0, jsx_runtime_1.jsx)(RadioGroup.Root, __assign({}, props, { loop: true, "data-sr-feedback-widget-emotion-field-buttons": "", value: field.value, "aria-label": "Pick an emotion", onValueChange: function (value) {
                    return field.onChange({ target: { value: value, name: props.name } });
                }, children: [':heart_eyes:', ':wave:', ':sob:'].map(function (emotion) { return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(RadioGroup.Item, { value: emotion, children: [(0, client_1.getEmoji)(emotion).image, (0, jsx_runtime_1.jsx)(RadioGroup.Indicator, {})] }, emotion) })); }) }))] }));
};
exports.EmotionField = EmotionField;
var CategoryField = function (props) {
    var field = (0, formik_1.useField)({ name: props.name })[0];
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-category-field": "", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "context.emotion", children: "Category" }), (0, jsx_runtime_1.jsx)(RadioGroup.Root, __assign({}, props, { "data-sr-feedback-widget-category-field-buttons": "", value: field.value, "aria-label": "Pick a category", onValueChange: function (value) {
                    return field.onChange({ target: { value: value, name: props.name } });
                }, loop: true, children: ['general', 'help'].map(function (category) { return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(RadioGroup.Item, { value: category, id: "r1", children: [(0, jsx_runtime_1.jsx)(RadioGroup.Indicator, {}), category] }, category) })); }) }))] }));
};
exports.CategoryField = CategoryField;
var OptionalTextField = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Additional Information' : _b, errors = _a.errors, touched = _a.touched, isSubmitted = _a.isSubmitted;
    var field = (0, formik_1.useField)({ name: 'text' })[0];
    var editor = (0, react_2.useEditor)({
        // @ts-ignore
        extensions: [starter_kit_1.default, extension_highlight_1.default, extension_typography_1.default, extension_link_1.default],
        content: field.value,
        onUpdate: function (_a) {
            var editor = _a.editor;
            field.onChange({ target: { value: editor.getHTML(), name: 'text' } });
        },
        onBlur: function (_a) {
            var event = _a.event;
            field.onBlur(event);
        },
        editorProps: {
            attributes: {
                id: 'text',
                name: 'text',
            },
        },
    });
    var isEmpty = editor === null || editor === void 0 ? void 0 : editor.isEmpty;
    react_1.default.useEffect(function () {
        var _a;
        if (isEmpty) {
            field.onChange({ target: { value: '', name: 'text' } });
        }
        if (isSubmitted) {
            (_a = editor === null || editor === void 0 ? void 0 : editor.commands) === null || _a === void 0 ? void 0 : _a.clearContent();
        }
    }, [isEmpty, isSubmitted]);
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-feedback-field": "", children: [(0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-feedback-field-header": "", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "text", children: [label, " ", (0, jsx_runtime_1.jsx)("span", { children: "(optional)" })] }), errors.text && touched.text ? ((0, jsx_runtime_1.jsx)("div", { "aria-live": "polite", children: errors.text })) : null] }), (0, jsx_runtime_1.jsx)("div", { "data-sr-feedback-widget-feedback-field": errors.text && touched.text ? 'error' : '', children: (0, jsx_runtime_1.jsx)(react_2.EditorContent, { editor: editor, name: "text", id: "text" }) })] }));
};
exports.OptionalTextField = OptionalTextField;
var SeatSelectionField = function (props) {
    var _a = (0, formik_1.useField)({ name: 'numberOfSeats' }), field = _a[0], meta = _a[1], helpers = _a[2];
    var handleChange = function (event) {
        var value = Math.max(5, parseInt(event.target.value, 10) || 5);
        if (value !== field.value) {
            helpers.setValue(value);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { "data-sr-feedback-widget-seat-selection-field": "", children: [(0, jsx_runtime_1.jsxs)("label", { htmlFor: "numberOfSeats", children: ["Number of Seats ", (0, jsx_runtime_1.jsx)("span", { children: "(required)" })] }), (0, jsx_runtime_1.jsx)("input", __assign({}, field, props, { type: "number", min: "5", onChange: handleChange, value: field.value || 5, "data-sr-feedback-widget-seat-selection-field-input": "" })), meta.touched && meta.error ? ((0, jsx_runtime_1.jsx)("div", { "data-sr-feedback-widget-seat-selection-field-error": "", children: meta.error })) : null] }));
};
exports.SeatSelectionField = SeatSelectionField;
